import { useState, useEffect } from "react";
import "./styles/memarea.scss";
import { motion } from "framer-motion";
import { useAuth } from "../../pages/login/AuthProvider";
import axios from "axios";
import { backend, member } from "../../components/apipath";
import { Navigate, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import EditableAddress from "../registration/component/editableAddress";

function Memarea() {
    const [redirect, setRedirect] = useState(false);
    const { token, mem_id } = useAuth();
    const [memBackData, setMemBackData] = useState({
        mem_id: "",
        chinese_name: "",
        account: "",
        phone_num: "",
        email: "",
        id_num: "",
        school: "",
        fname: "",
        lname: "",
        status: "",
        address: "",
        course: [],
        info_way: [],
        company: "",
    });
    const [errors, setErrors] = useState({});
    const [showCourses, setShowCourses] = useState(false);
    
    const [passwordData, setPasswordData] = useState({
        oldPassword: "",
        newPassword: "",
        repassword: "",
    });

    const [showPasswordFields, setShowPasswordFields] = useState(false);
    const [passwordErrors, setPasswordErrors] = useState({});
    const navigate = useNavigate();
    
    useEffect(() => {
        const fetchMemAreaData = async () => {
            try {
                if (mem_id) {
                    const response = await axios.get(`${backend}member/memareaData/${mem_id}`);
                    if (response.data && response.data.length > 0) {
                        const fetchedData = response.data[0];
                        setMemBackData({
                            mem_id: mem_id || "",
                            chinese_name: fetchedData.chinese_name || "",
                            phone_num: fetchedData.phone_num || "",
                            email: fetchedData.account || fetchedData.email || "",
                            account: fetchedData.account || "",
                            id_num: fetchedData.id_num || "",
                            school: fetchedData.school || "",
                            fname: fetchedData.first_name || "",
                            lname: fetchedData.last_name || "",
                            status: fetchedData.status || "",
                            address: fetchedData.address || "",
                            course: fetchedData.course || [],
                            info_way: fetchedData.info_way ? fetchedData.info_way.split(",") : [],
                            company: fetchedData.company_name || "",
                        });
                        setShowCourses(fetchedData.deliver === "快遞");
                    } else {
                        console.error("No member data found.");
                    }
                }
                
            } catch (error) {
                console.error("Error fetching member area data:", error);
            }
        };

        fetchMemAreaData();
    }, [mem_id]);
    
    useEffect(() => {
        const auth = JSON.parse(localStorage.getItem("auth"));
        if (!auth || !auth.token) {
            Swal.fire({
                icon: "warning",
                color: "#224040",
                text: "尚未登入會員",
            }).then(() => {
                setRedirect(true);
            });
        }
    }, []);
    // useEffect(() => {
    //     console.log("Updated memBackData:", memBackData);
    // }, [memBackData]); 

    if (redirect) {
        return <Navigate to="/member/memberlogin" replace />;
    }
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setMemBackData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value });
    };

    const validatePassword = () => {
        const errors = {};
        if (!passwordData.oldPassword) {
            errors.oldPassword = "請輸入舊密碼";
        }
        if (!passwordData.newPassword) {
            errors.newPassword = "請輸入新密碼";
        } else if (passwordData.newPassword.length < 6) {
            errors.newPassword = "密碼長度至少為6個字元";
        }
        if (passwordData.newPassword !== passwordData.repassword) {
            errors.repassword = "新密碼與確認密碼不一致";
        }
        setPasswordErrors(errors);
        return Object.keys(errors).length === 0;
    };

    
    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
    
        if (!validatePassword()) {
            Swal.fire({
                icon: "error",
                title: "提交失敗",
                text: "請檢查密碼欄位的錯誤。",
            });
            return;
        }
    
        try {
            const authData = JSON.parse(localStorage.getItem("auth")) || {};
            const token = authData.token;
            const mem_id = authData.mem_id || "";
    
            if (!token) {
                Swal.fire({
                    icon: "error",
                    title: "驗證失敗",
                    text: "無法獲取登入 Token，請重新登入。",
                });
                return;
            }
    
            const requestBody = {
                mem_id: mem_id,
                oldPassword: passwordData.oldPassword,
                newPassword: passwordData.newPassword,
                repassword: passwordData.repassword
            };
    
            // **發送請求**
            const response = await axios.put(`${member}/resetpassword`, requestBody, {
                headers: { token: token },
            });
    
            // console.log("伺服器回應:", response.data); // 確認後端的回傳格式
    
            // **手動檢查 `response.data.status`**
            if (response.data.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "密碼已更新",
                    text: "您的密碼已成功更改。",
                });
                setShowPasswordFields(false);
                setPasswordData({ oldPassword: "", newPassword: "", repassword: "" });
            } else {
                throw new Error(response.data?.msg || "密碼更新失敗，請稍後再試。");
            }
    
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "更新失敗",
                text: error.response?.data?.msg || error.message || "無法更新密碼，請稍後再試。",
            });
    
            console.error("密碼更新錯誤:", error);
        }
    };
    
    
    
    
    const updatedMemBackData = {
        ...memBackData,
        info_way: memBackData.info_way.length ? memBackData.info_way : "",
    };

    
    

    // const handleinfoChange = (e) => {
    //     const { value, checked } = e.target;
    //     setMemBackData((prevData) => ({
    //         ...prevData,
    //         info_way: checked
    //             ? [...(prevData.info_way || []), value]
    //             : prevData.info_way.filter((item) => item !== value),
    //     }));
    // };
    
    // const handleCourseSelection = (e) => {
    //     const { value, checked } = e.target;
    //     setMemBackData((prevData) => ({
    //         ...prevData,
    //         course: checked
    //             ? [...(prevData.course || []), value]
    //             : prevData.course.filter((item) => item !== value),
    //     }));
    // };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["chinese_name", "phone_num", "email", "id_num", "school", "status"];

        requiredFields.forEach((field) => {
            if (!memBackData[field]) {
                newErrors[field] = "此欄位為必填項";
            }
        });

        if (memBackData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(memBackData.email)) {
            newErrors.email = "請輸入有效的電子郵件";
        }

        if (memBackData.phone_num && !/^(\+?886\-?|0)?9\d{8}$/.test(memBackData.phone_num)) {
            newErrors.phone_num = "請輸入有效的電話號碼";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!validateForm()) {
            Swal.fire({
                icon: "error",
                title: "提交失敗",
                text: "請檢查表單中的錯誤。",
            });
            return;
        }
    
        try {
            const authData = JSON.parse(localStorage.getItem("auth")) || {};
            const token = authData.token;
    
            if (!token) {
                Swal.fire({
                    icon: "error",
                    title: "驗證失敗",
                    text: "無法獲取登入 Token，請重新登入。",
                });
                return;
            }
    
            // **創建 API 傳送的物件**
            const requestBody = { ...memBackData };
    
            // **移除 info_way，如果它是空的**
            if (!requestBody.info_way.length) {
                delete requestBody.info_way;
            } else {
                requestBody.info_way = requestBody.info_way.join(","); // 轉換成字串
            }
    
            await axios.put(`${member}/updateMemAreaData`, requestBody, {
                headers: { "Content-Type": "application/json", token: token },
                withCredentials: true
            });
    
            Swal.fire({
                icon: "success",
                title: "資料已更新",
                text: "您的資料已成功儲存。",
            });
            navigate("/member");
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "更新失敗",
                text: error.response?.data || "請稍後再試。",
            });
            console.error("Failed to update data:", error);
        }
    };
    

    return (
        <>
            <div className="banner">
                <motion.div
                    initial={{ opacity: 0, x: -100 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4, default: { ease: "linear" } }}
                >
                    <img src="/memberImg/login_banner.jpg" alt="" />
                </motion.div>
            </div>
            <div className="container mb100 mt100">
                <div className="beckertitlename mt100 mb-5">會員基本資料</div>
                <div className="card w-75 p-5 m-auto">
                    <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        {/* 中文全名 */}
                        <div className="form-group mb-4">
                            <label htmlFor="chinese_name" className="mb-2">*中文全名</label>
                            <input
                                className={`form-control ${errors.chinese_name && "is-invalid"}`}
                                type="text"
                                name="chinese_name"
                                value={memBackData.chinese_name}
                                onChange={handleChange}
                            />
                            {errors.chinese_name && <div className="invalid-feedback">{errors.chinese_name}</div>}
                        </div>

                        {/* 英文拼音全名 */}
                        <div className="form-group mb-4">
                            <label className="mb-2">*英文拼音全名</label>
                            <div className="row">
                                <div className="col">
                                    <input
                                        type="text"
                                        className={`form-control ${errors.fname && "is-invalid"}`}
                                        placeholder="First name"
                                        name="fname"
                                        value={memBackData.fname}
                                        onChange={handleChange}
                                    />
                                    {errors.fname && <div className="invalid-feedback">{errors.fname}</div>}
                                </div>
                                <div className="col">
                                    <input
                                        type="text"
                                        className={`form-control ${errors.lname && "is-invalid"}`}
                                        placeholder="Last name"
                                        name="lname"
                                        value={memBackData.lname}
                                        onChange={handleChange}
                                    />
                                    {errors.lname && <div className="invalid-feedback">{errors.lname}</div>}
                                </div>
                            </div>
                            <small id="enameHelp" className="form-text text-muted">同護照上顯示之英文名，例：Da-Ming, Wang</small>
                        </div>



                        {/* 帳號 */}
                        <div className="form-group mb-4">
                                <label htmlFor="email" className="mb-2">*帳號</label>
                                <input
                                    type="email"
                                    className={`form-control ${errors.account && "is-invalid"}`}
                                    id="email"
                                    name="email"
                                    value={memBackData.account}
                                    readOnly
                                />
                                {errors.email && <div className="invalid-feedback">{errors.account}</div>}
                            </div>

                            {/* 更改密碼按鈕 */}
                            {!showPasswordFields && (
                                <button
                                    type="button"
                                    className="btn btn-secondary mb-4"
                                    onClick={() => setShowPasswordFields(true)}
                                >
                                    更改密碼
                                </button>
                            )}

                            {/* 新密碼與確認密碼欄位 */}
                            {showPasswordFields && (
                                <>
                                    <div className="form-group mb-4">
                                        <label htmlFor="oldPassword" className="mb-2">舊密碼</label>
                                        <input
                                            type="password"
                                            className={`form-control ${passwordErrors.oldPassword && "is-invalid"}`}
                                            id="oldPassword"
                                            name="oldPassword"
                                            value={passwordData.oldPassword}
                                            onChange={handlePasswordChange}
                                        />
                                        {passwordErrors.oldPassword && (
                                            <div className="invalid-feedback">{passwordErrors.oldPassword}</div>
                                        )}
                                    </div>
                                    <div className="form-group mb-4">
                                        <label htmlFor="newPassword" className="mb-2">新密碼</label>
                                        <input
                                            type="password"
                                            className={`form-control ${passwordErrors.newPassword && "is-invalid"}`}
                                            id="newPassword"
                                            name="newPassword"
                                            value={passwordData.newPassword}
                                            onChange={handlePasswordChange}
                                        />
                                        {passwordErrors.newPassword && (
                                            <div className="invalid-feedback">{passwordErrors.newPassword}</div>
                                        )}
                                    </div>

                                    <div className="form-group mb-4">
                                        <label htmlFor="repassword" className="mb-2">確認新密碼</label>
                                        <input
                                            type="password"
                                            className={`form-control ${passwordErrors.repassword && "is-invalid"}`}
                                            id="repassword"
                                            name="repassword"
                                            value={passwordData.repassword}
                                            onChange={handlePasswordChange}
                                        />
                                        {passwordErrors.repassword && (
                                            <div className="invalid-feedback">{passwordErrors.repassword}</div>
                                        )}
                                    </div>

                                    <button
                                        type="button"
                                        className="btn btn-primary mb-5"
                                        onClick={handlePasswordSubmit}
                                    >
                                        密碼更改
                                    </button>
                                </>
                            )}


                        {/* 聯絡電話 */}
                        <div className="form-group mb-4">
                            <label htmlFor="phone_num" className="mb-2">*聯絡電話</label>
                            <input
                                type="tel"
                                className={`form-control ${errors.phone_num && "is-invalid"}`}
                                id="phone_num"
                                name="phone_num"
                                value={memBackData.phone_num}
                                onChange={handleChange}
                            />
                            {errors.phone_num && <div className="invalid-feedback">{errors.phone_num}</div>}
                        </div>

                        {/* 電子郵件 */}
                        <div className="form-group mb-4">
                            <label htmlFor="email" className="mb-2">*電子郵件</label>
                            <input
                                type="email"
                                className={`form-control ${errors.email && "is-invalid"}`}
                                id="email"
                                name="email"
                                value={memBackData.email}
                                onChange={handleChange}
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            <small id="emailHelp" className="form-text text-muted">
                                將依此註冊您的 Becker 教材帳號。若您曾經購買或試用過任何 Becker 產品，請提供「尚未用來註冊過 Becker」的電子郵件住址
                            </small>
                        </div>

                        {/* 身分證字號 */}
                        <div className="form-group mb-4">
                            <label htmlFor="id_num" className="mb-2">*身分證字號</label>
                            <input
                                type="text"
                                className={`form-control ${errors.id_num && "is-invalid"}`}
                                id="id_num"
                                name="id_num"
                                value={memBackData.id_num}
                                onChange={handleChange}
                            />
                            {errors.id_num && <div className="invalid-feedback">{errors.id_num}</div>}
                        </div>

                        {/* 學校與科系 */}
                        <div className="form-group mb-4">
                            <label htmlFor="school" className="mb-2">*所屬(或畢業)學校與科系</label>
                            <input
                                type="text"
                                className={`form-control ${errors.school && "is-invalid"}`}
                                id="school"
                                name="school"
                                value={memBackData.school}
                                onChange={handleChange}
                            />
                            {errors.school && <div className="invalid-feedback">{errors.school}</div>}
                        </div>

                        {/* 職業 */}
                        <div className="form-group mb-4">
                            <label htmlFor="status" className="mb-2">*目前職業</label>
                            <select
                                className={`form-control ${errors.status && "is-invalid"}`}
                                id="status"
                                name="status"
                                value={memBackData.status || ""}
                                onChange={handleChange}
                            >
                                <option value="" disabled>請選擇職業</option>
                                <option value="incumbent">在職者</option>
                                <option value="student">在學生</option>
                                <option value="candidates">全職考生</option>
                                <option value="unemployed">待業中</option>
                            </select>
                            {errors.status && <div className="invalid-feedback">{errors.status}</div>}
                        </div>
                        <div className={`form-group mb-4 ${errors.address ? "is-invalid" : ""}`}>
                            <label htmlFor="address" className="mb-2">*地址</label>
                            <EditableAddress
                                initialAddress={memBackData.address || ""} // 從資料庫初始化地址
                                onAddressChange={(newAddress) => setMemBackData({ ...memBackData, address: newAddress })}
                            />
                            {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                        </div>

                        {/* 提交按鈕 */}
                        <button type="submit" className="btn btn-primary">儲存資料</button>
                    </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Memarea;
